// extracted by mini-css-extract-plugin
export default {"animated-icon":"mAZF70It--AnimatedIcon_animated-icon__Ww7TM","animatedIcon":"mAZF70It--AnimatedIcon_animated-icon__Ww7TM"};